const selector = ".bg-picture"
const imgXlWidth = 1200


const updateBgPic = (el, index) => {
  const wW = window.innerWidth
  const highestLoaded = el.dataset.highestLoaded
  if (highestLoaded && (highestLoaded >= wW || highestLoaded >= imgXlWidth)) {
    return
  }
  let src
  let highestW
  const listOfSrcs = [...el.querySelectorAll("source")]
  listOfSrcs.forEach((s, index) => {
    const minW = parseInt(s.dataset.minWidth)
    if (wW >= minW) {
      if (!highestW || highestW < minW) {
        src = s.srcset
        highestW = minW
      }
    }
  })
  if (!src) {
    // window width < lowest entry...
    const img = el.querySelector("img")
    src = img ? img.srcset : null
  }
  if (src) {
    el.style.backgroundImage = "url(" + src + ")"
    el.dataset.highestLoaded = highestW
  }
}


export const updateBgPictures = () => {
  const list = [...document.querySelectorAll(selector)] 
  list.forEach(updateBgPic)
}